import { render, staticRenderFns } from "./getToken.vue?vue&type=template&id=2a1c5604&scoped=true&"
import script from "./getToken.vue?vue&type=script&lang=js&"
export * from "./getToken.vue?vue&type=script&lang=js&"
import style0 from "./getToken.vue?vue&type=style&index=0&id=2a1c5604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1c5604",
  null
  
)

export default component.exports